"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var tippy_js_1 = __importDefault(require("tippy.js"));
(0, jquery_1.default)(function () {
    (0, jquery_1.default)('.add-tooltip').each(function () {
        var $tooltip = (0, jquery_1.default)(this);
        var content = $tooltip.data("tooltip-text");
        (0, tippy_js_1.default)($tooltip.get(0), {
            content: content,
            allowHTML: true
        });
    });
});
